import classnames from "classnames";
import React, { useCallback, useMemo } from "react";

import TextPlaceholder from "features/common/components/TextPlaceholder";

import "./Checkbox.scss";

export type Props = {
  selected?: boolean;
  onChange?: (e: React.SyntheticEvent<any>) => void;
  text?: string;
  className?: string;
  checkboxClassName?: string;
  checkboxLabelClassName?: string;
  checkboxSelectedClassName?: string;
  loading?: boolean;
  disabled?: boolean;
  onClick?: (e: React.SyntheticEvent<any>) => void;
};

export default function Checkbox(props: Props) {
  const id = useMemo(
    () => `FormCheckbox--${Math.random().toString().replace(/0\./, "")}`,
    []
  );

  const {
    selected,
    text,
    className,
    onChange,
    checkboxClassName,
    checkboxSelectedClassName,
    loading,
    disabled,
    checkboxLabelClassName,
    onClick
  } = props;

  const handleLabelClick = useCallback(
    (event: any) => event.stopPropagation(),
    []
  );

  return (
    <div
      className={classnames("Checkbox", className, {
        "Checkbox--loading": loading,
        "Checkbox--disabled": disabled
      })}
    >
      <input
        className="Checkbox__input"
        type="checkbox"
        defaultChecked={selected}
        id={id}
        onChange={onChange}
        onClick={onClick}
      />
      <label
        onClick={handleLabelClick}
        htmlFor={id}
        className="Checkbox__labelWrapper"
      >
        <span
          className={classnames(
            "Checkbox__checkbox",
            checkboxClassName,
            selected ? checkboxSelectedClassName : "",
            {
              "Checkbox__checkbox--checked": selected
            }
          )}
        />
        <TextPlaceholder loading={loading} placeholderWidth="7em">
          <span
            className={classnames("Checkbox__label", checkboxLabelClassName)}
          >
            {text}
          </span>
        </TextPlaceholder>
      </label>
    </div>
  );
}
